import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z"
}), 'Dehaze');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Dehaze.js
// module id = 3063
// module chunks = 2